import * as React from "react";
import { Button, Input } from "@fluentui/react-components";
import { DismissRegular, SearchRegular } from "@fluentui/react-icons";
import { useIconPickerStyles } from "./iconPickerStyles";

interface Props {
  search: string;
  onClear: () => void;
  onSearchChange: (value: string) => void;
}

const IconPickerSearch: React.FC<Props> = ({ search, onClear, onSearchChange }) => {
  const styles = useIconPickerStyles();

  return (
    <div className={styles.searchContainer}>
      <Input
        className={styles.searchInput}
        contentBefore={<SearchRegular />}
        contentAfter={
          search ? <Button appearance="subtle" icon={<DismissRegular />} onClick={onClear} /> : undefined
        }
        placeholder="Search icons..."
        value={search}
        onChange={(_, data) => onSearchChange(data.value)}
      />
    </div>
  );
};

export default IconPickerSearch;
